import React from 'react';
import PropTypes from 'prop-types';
import MarkushValue from '@Components/Results/substances/tables/markush/MarkushValue';
import StructurePreview from '@Components/Results/structure/StructurePreview';

function MarkushGroup({ uid, group }) {
  return (
    <tbody id={`${uid}-${group.label}`} className="table__body c-els-table__body u-els-font-size-base">
      {Array.isArray(group.members) &&
        group.members.map((member, index) => (
          <tr key={member?.id || index} className="table__row c-els-table__row no-hover-background">
            <td className="table__cell c-els-table__cell c-els-table__basic-cell">{index === 0 ? group.label : ''}</td>
            {!member?.path && (
              <td className="table__cell c-els-table__cell c-els-table__basic-cell">
                <MarkushValue value={member?.data?.value} uid={uid} />
              </td>
            )}
            {member?.path && (
              <td className="table__cell c-els-table__cell c-els-table__basic-cell markush-picture">
                <StructurePreview markushPreview={member.path} />
              </td>
            )}
            <td className="table__cell c-els-table__cell c-els-table__basic-cell">{member?.data?.size}</td>
            <td className="table__cell c-els-table__cell c-els-table__basic-cell">{member?.data?.attributes}</td>
            <td className="table__cell c-els-table__cell c-els-table__basic-cell">
              {member?.data && <MarkushValue value={member.data.substitutedBy} uid={uid} />}
            </td>
            <td className="table__cell c-els-table__cell c-els-table__basic-cell">{member?.data?.frequency}</td>
          </tr>
        ))}
    </tbody>
  );
}

MarkushGroup.propTypes = {
  uid: PropTypes.string.isRequired,
  group: PropTypes.object.isRequired,
};

export default MarkushGroup;
